// Shared MUI DataGrid styling so every table in the app looks the same:
//  - neutral alternating stripes (no type-based coloring — VO/Contract/etc.
//    rows are NOT colored differently; the whole table uses one pattern)
//  - clear hover state
//  - strongly highlighted selected row: a solid blue fill across the whole
//    line, darker bold text and a 4px accent bar on the left edge so the
//    user can immediately see which row is selected.
//
// Pages import `dataGridSx` into the DataGrid's `sx` prop. File-specific
// overrides can be spread after this (e.g. `sx={{ ...dataGridSx, ... }}`).

// Typed as a plain record (not SxProps<Theme>) so pages can spread it with
// `{ ...dataGridSx, ...overrides }` without casts. MUI accepts this shape.
export const dataGridSx = {
  border: 0,
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#f5f5f5',
    fontWeight: 600,
    fontSize: 12,
    color: '#666',
    borderBottom: '2px solid #e0e0e0'
  },
  '& .MuiDataGrid-cell': {
    fontSize: 13,
    color: '#555',
    borderBottom: '1px solid #f0f0f0'
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none'
  },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none'
  },
  '& .MuiDataGrid-row': {
    // Neutral alternating stripes — identical for every row regardless of
    // its type (VO, Contract, MR, etc.). One uniform pattern per table.
    '&:nth-of-type(even)': {
      backgroundColor: '#fafafa'
    },
    '&:hover': {
      backgroundColor: '#eef1f5 !important'
    },
    // Selected row: a strong, unmistakable highlight. The whole line gets a
    // solid blue tint, the text turns dark navy + semi-bold, and a 4px accent
    // bar runs down the left edge.
    '&.Mui-selected': {
      position: 'relative',
      backgroundColor: 'rgba(25, 118, 210, 0.32) !important',
      '& .MuiDataGrid-cell': {
        color: '#0d2a4d',
        fontWeight: 600
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '4px',
        backgroundColor: '#1976d2',
        zIndex: 3
      },
      '&:hover': {
        backgroundColor: 'rgba(25, 118, 210, 0.42) !important'
      }
    }
  }
};
